/* eslint-disable camelcase */
// node modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';

// app modules: components
import CollectionImage from 'components/CollectionImage';
import CollectionOptionsMenu from 'components/Collection/OptionsMenu';
import FavouriteButton from 'components/FavouriteButton';
import Icon from 'components/Icon';
import Link from 'components/Link';

// app modules: services
import route from 'services/route';
import { getImageSrc } from 'services/image';

// app modules: props
import RecipeImageProps from 'components/RecipeImage/RecipeImageProps';

// app modules: constants
import { COLOURS, CONTENT_TYPES } from 'constants/index';

// assets
import CssDescriptiveItem from './DescriptiveItem.scss';

class SearchCollectionItem extends Component {
  static propTypes = {
    item: PropTypes.shape({
      authors: PropTypes.arrayOf(PropTypes.string),
      id: PropTypes.number,
      image: RecipeImageProps.graphic,
      title: PropTypes.string,
      description: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func,
    wide: PropTypes.bool,
  };

  static defaultProps = {
    onClick: () => {},
    wide: false,
  };

  render() {
    const { item, onClick, wide } = this.props;
    const { id, title, authors, image, item_count } = item;
    const renderedImage = (
      <CollectionImage
        contentImage={image && image.src ? null : image}
        overrideImage={image && image.src ? image.src : null}
        width={125}
        height={125}
        bookCoverWidth={100}
        bookCoverHeight={100}
      />
    );
    let imageToShare;
    if (item.image?.primary_image) {
      imageToShare = getImageSrc(item.image.primary_image, 'square', size => size.w >= 250, {
        searchHighToLow: true,
      });
    }

    return (
      <div className={classNames('descriptive-item', { 'descriptive-item--wide': wide })}>
        <Link
          className="descriptive-item__wrapper"
          to={route.collection.view({ id, name: title })}
          onClick={onClick}
        >
          <header className="descriptive-item__header">
            <p
              className={classNames('descriptive-item__title', {
                'descriptive-item--wide__title': wide,
              })}
            >
              {title}
            </p>
          </header>

          <div className="descriptive-item__body">
            <div className="descriptive-item__images">{renderedImage}</div>
            <div className="descriptive-item__content-wrapper">
              <p className="descriptive-item__content">{item.description}</p>
            </div>
          </div>
          <div className="descriptive-item__footer">
            <p className="descriptive-item__footer__paragraph">
              <span className="descriptive-item__footer__paragraph--bold">{item_count} items</span>
              <br />
              {authors ? authors.join(', ') : null}
            </p>
          </div>
        </Link>
        {/* Interactive elements are overlayed using CSS to avoid nesting them inside the <a> tag. */}
        <div className="descriptive-item__button-wrapper">
          <div className="descriptive-item__buttons">
            <FavouriteButton contentId={id} contentType={CONTENT_TYPES.COLLECTION} />
            <CollectionOptionsMenu
              collection={{ ...item, visibility: 'public' }}
              image={renderedImage}
              heading={title}
              shareImageUrl={imageToShare}
            >
              <Icon fill={COLOURS.ENERGIZED} name="dots" height="20" width="20" />
            </CollectionOptionsMenu>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(CssDescriptiveItem)(SearchCollectionItem);
